import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import appAz from './locales/az/app.json';
import authAz from './locales/az/auth.json';
import headerAz from './locales/az/header.json';
import navAz from './locales/az/nav.json';
import commonAz from './locales/az/common.json';
import conversationsAz from './locales/az/conversations.json';
import patientsAz from './locales/az/patients.json';
import assetsAz from './locales/az/assets.json';
import productsAz from './locales/az/products.json';
import servicesAz from './locales/az/services.json';
import invoicesAz from './locales/az/invoices.json';
import contactsAz from './locales/az/contacts.json';
import adminAz from './locales/az/admin.json';
import companiesAz from './locales/az/companies.json';
import connectorsAz from './locales/az/connectors.json';
import calendarAz from './locales/az/calendar.json';
import rosteringAz from './locales/az/rostering.json';
import fieldOperationsAz from './locales/az/fieldOperations.json';
import tasksAz from './locales/az/tasks.json';
import knowledgeAz from './locales/az/knowledge.json';
import orchestratorsAz from './locales/az/orchestrators.json';
import apiToolsAz from './locales/az/apiTools.json';
import toolsAz from './locales/az/tools.json';
import toolPluginsAz from './locales/az/toolPlugins.json';
import mcpAz from './locales/az/mcp.json';
import consultationsAz from './locales/az/consultations.json';
import aiActivityAz from './locales/az/aiActivity.json';
import aiUsageAz from './locales/az/aiUsage.json';
import billingAz from './locales/az/billing.json';
import reminderEngineAz from './locales/az/reminderEngine.json';
import webWidgetAz from './locales/az/webWidget.json';
import commentAutomationsAz from './locales/az/commentAutomations.json';
import dmAutomationsAz from './locales/az/dmAutomations.json';
import automationsAz from './locales/az/automations.json';
import workspacesAz from './locales/az/workspaces.json';
import appEn from './locales/en/app.json';
import authEn from './locales/en/auth.json';
import headerEn from './locales/en/header.json';
import navEn from './locales/en/nav.json';
import commonEn from './locales/en/common.json';
import conversationsEn from './locales/en/conversations.json';
import patientsEn from './locales/en/patients.json';
import assetsEn from './locales/en/assets.json';
import productsEn from './locales/en/products.json';
import servicesEn from './locales/en/services.json';
import invoicesEn from './locales/en/invoices.json';
import contactsEn from './locales/en/contacts.json';
import adminEn from './locales/en/admin.json';
import companiesEn from './locales/en/companies.json';
import connectorsEn from './locales/en/connectors.json';
import calendarEn from './locales/en/calendar.json';
import rosteringEn from './locales/en/rostering.json';
import fieldOperationsEn from './locales/en/fieldOperations.json';
import tasksEn from './locales/en/tasks.json';
import knowledgeEn from './locales/en/knowledge.json';
import orchestratorsEn from './locales/en/orchestrators.json';
import apiToolsEn from './locales/en/apiTools.json';
import toolsEn from './locales/en/tools.json';
import toolPluginsEn from './locales/en/toolPlugins.json';
import mcpEn from './locales/en/mcp.json';
import consultationsEn from './locales/en/consultations.json';
import aiActivityEn from './locales/en/aiActivity.json';
import aiUsageEn from './locales/en/aiUsage.json';
import billingEn from './locales/en/billing.json';
import reminderEngineEn from './locales/en/reminderEngine.json';
import webWidgetEn from './locales/en/webWidget.json';
import commentAutomationsEn from './locales/en/commentAutomations.json';
import dmAutomationsEn from './locales/en/dmAutomations.json';
import automationsEn from './locales/en/automations.json';
import workspacesEn from './locales/en/workspaces.json';
import appTr from './locales/tr/app.json';
import authTr from './locales/tr/auth.json';
import headerTr from './locales/tr/header.json';
import navTr from './locales/tr/nav.json';
import commonTr from './locales/tr/common.json';
import conversationsTr from './locales/tr/conversations.json';
import patientsTr from './locales/tr/patients.json';
import assetsTr from './locales/tr/assets.json';
import productsTr from './locales/tr/products.json';
import servicesTr from './locales/tr/services.json';
import invoicesTr from './locales/tr/invoices.json';
import contactsTr from './locales/tr/contacts.json';
import adminTr from './locales/tr/admin.json';
import companiesTr from './locales/tr/companies.json';
import connectorsTr from './locales/tr/connectors.json';
import calendarTr from './locales/tr/calendar.json';
import rosteringTr from './locales/tr/rostering.json';
import fieldOperationsTr from './locales/tr/fieldOperations.json';
import tasksTr from './locales/tr/tasks.json';
import knowledgeTr from './locales/tr/knowledge.json';
import orchestratorsTr from './locales/tr/orchestrators.json';
import apiToolsTr from './locales/tr/apiTools.json';
import toolsTr from './locales/tr/tools.json';
import toolPluginsTr from './locales/tr/toolPlugins.json';
import mcpTr from './locales/tr/mcp.json';
import consultationsTr from './locales/tr/consultations.json';
import aiActivityTr from './locales/tr/aiActivity.json';
import aiUsageTr from './locales/tr/aiUsage.json';
import billingTr from './locales/tr/billing.json';
import reminderEngineTr from './locales/tr/reminderEngine.json';
import webWidgetTr from './locales/tr/webWidget.json';
import commentAutomationsTr from './locales/tr/commentAutomations.json';
import dmAutomationsTr from './locales/tr/dmAutomations.json';
import automationsTr from './locales/tr/automations.json';
import workspacesTr from './locales/tr/workspaces.json';

export const DEFAULT_LANGUAGE = 'az';
export const LANGUAGE_STORAGE_KEY = 'appLanguage';
export const SUPPORTED_LANGUAGES = ['az', 'en', 'tr'] as const;

const getInitialLanguage = (): string => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)?.trim().toLowerCase();
    if (stored && SUPPORTED_LANGUAGES.includes(stored as typeof SUPPORTED_LANGUAGES[number])) {
      return stored;
    }
  } catch {}

  return DEFAULT_LANGUAGE;
};

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      az: {
        app: appAz,
        auth: authAz,
        header: headerAz,
        nav: navAz,
        common: commonAz,
        conversations: conversationsAz,
        patients: patientsAz,
        assets: assetsAz,
        products: productsAz,
        services: servicesAz,
        invoices: invoicesAz,
        contacts: contactsAz,
        admin: adminAz,
        companies: companiesAz,
        connectors: connectorsAz,
        calendar: calendarAz,
        rostering: rosteringAz,
        fieldOperations: fieldOperationsAz,
        tasks: tasksAz,
        knowledge: knowledgeAz,
        orchestrators: orchestratorsAz,
        apiTools: apiToolsAz,
        tools: toolsAz,
        toolPlugins: toolPluginsAz,
        mcp: mcpAz,
        consultations: consultationsAz,
        aiActivity: aiActivityAz,
        aiUsage: aiUsageAz,
        billing: billingAz,
        reminderEngine: reminderEngineAz,
        webWidget: webWidgetAz,
        commentAutomations: commentAutomationsAz,
        dmAutomations: dmAutomationsAz,
        automations: automationsAz,
        workspaces: workspacesAz,
      },
      en: {
        app: appEn,
        auth: authEn,
        header: headerEn,
        nav: navEn,
        common: commonEn,
        conversations: conversationsEn,
        patients: patientsEn,
        assets: assetsEn,
        products: productsEn,
        services: servicesEn,
        invoices: invoicesEn,
        contacts: contactsEn,
        admin: adminEn,
        companies: companiesEn,
        connectors: connectorsEn,
        calendar: calendarEn,
        rostering: rosteringEn,
        fieldOperations: fieldOperationsEn,
        tasks: tasksEn,
        knowledge: knowledgeEn,
        orchestrators: orchestratorsEn,
        apiTools: apiToolsEn,
        tools: toolsEn,
        toolPlugins: toolPluginsEn,
        mcp: mcpEn,
        consultations: consultationsEn,
        aiActivity: aiActivityEn,
        aiUsage: aiUsageEn,
        billing: billingEn,
        reminderEngine: reminderEngineEn,
        webWidget: webWidgetEn,
        commentAutomations: commentAutomationsEn,
        dmAutomations: dmAutomationsEn,
        automations: automationsEn,
        workspaces: workspacesEn,
      },
      tr: {
        app: appTr,
        auth: authTr,
        header: headerTr,
        nav: navTr,
        common: commonTr,
        conversations: conversationsTr,
        patients: patientsTr,
        assets: assetsTr,
        products: productsTr,
        services: servicesTr,
        invoices: invoicesTr,
        contacts: contactsTr,
        admin: adminTr,
        companies: companiesTr,
        connectors: connectorsTr,
        calendar: calendarTr,
        rostering: rosteringTr,
        fieldOperations: fieldOperationsTr,
        tasks: tasksTr,
        knowledge: knowledgeTr,
        orchestrators: orchestratorsTr,
        apiTools: apiToolsTr,
        tools: toolsTr,
        toolPlugins: toolPluginsTr,
        mcp: mcpTr,
        consultations: consultationsTr,
        aiActivity: aiActivityTr,
        aiUsage: aiUsageTr,
        billing: billingTr,
        reminderEngine: reminderEngineTr,
        webWidget: webWidgetTr,
        commentAutomations: commentAutomationsTr,
        dmAutomations: dmAutomationsTr,
        automations: automationsTr,
        workspaces: workspacesTr,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

export const setAppLanguage = async (language: string) => {
  const normalized = language.trim().toLowerCase();
  const nextLanguage = SUPPORTED_LANGUAGES.includes(normalized as typeof SUPPORTED_LANGUAGES[number])
    ? normalized
    : DEFAULT_LANGUAGE;

  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
  } catch {}

  await i18n.changeLanguage(nextLanguage);
};

export default i18n;